// @core/api/endpoints/workflow/get_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineTemplateResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get pipeline template
 * Retrieves a pipeline template by ID, including the serialized pipeline schema.
 */
export async function GetTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<PipelineTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<PipelineTemplateResponse>(requestPath, { ...requestOptions });
}
